<template lang='pug'>
  div
    buy-modal()
    section.pricing__section.pricing__section--bg
      .pricing__container
        .pricing__container--title
          h1 Choose the plan that’s right for you
          p Whether you’re a Marketer, Photographer, Designer, Agency, or Enterprise, there’s a plan with Flixel apps and web services for your business.
          .toggle__container
            .toggle__item#toggle__item--yearly(@click='showYearly()', v-bind:class='{ toggleitemactive:!showingMonthly }')
              p Yearly
            .toggle__item#toggle__item--monthly(@click='showMonthly()', v-bind:class='{ toggleitemactive:showingMonthly }')
              p Monthly
          p.pricing__container--toggle Save up to 50% with a yearly plan!

        // Blendeo
        .pricing__container--grid
          .gridItem#mobile(v-show='showingBlendeo')
            .gridItem--image
                img.lazy(data-src='https://cdn.flixel.com/static/static-web/products/pricing/mobile.png')
            .gridItem--title
                h2 Blendeo
                h3 Create Moving Long Exposures
                p An advanced long exposure editor for iOS. Take control and change exposure time in post for motion blur or light trail photos or videos.
            .gridItem--pricing(v-if='showingMonthly')
                h4 {{blendeoMonthly}}
                    span  / month
                p Save {{blendeoYearlySave}} with  
                    a.link(@click='showYearly()') yearly billing
            .gridItem--pricing(v-if='!showingMonthly')
                h4 {{blendeoYearlyPerMonth}}
                    span / month
                p 
                    span {{blendeoYearly}} 
                    | billed yearly. 
                p Save {{blendeoYearlySave}} over  
                    a.link(@click='showMonthly()') monthly billing
                      
            .gridItem--pricing
                // Monthly button
                buy-button(
                    classes='btn btn--purpleLight',
                    product='blendeo-month',
                    copy='Buy Now',
                    v-if='showingMonthly'
                )
                // Yearly button
                buy-button(
                    classes='btn btn--purpleLight',
                    product='blendeo-year',
                    copy='Buy Now',
                    v-if='!showingMonthly'
                )
            .gridItem--subtitle
                h5.includeTitleDesktop Includes:
                h5.includeTitleMobile Includes:
                .moreFeatures#moreFeaturesMobile(@click='showFeature("mobile", "moreFeaturesMobile", "featuresMobile")')
                    h5 Show Features
                    i.fa.fa-chevron-down
            .gridItem__products
                .gridItem--product.gridItem--product--grey
                    h6
                      img.lazy(data-src='https://cdn.flixel.com/static/static-web/purchase/Check.svg')
                      | Blendeo
                      span &nbsp;for iOS
            .gridItem--features#featuresMobile
                ul.dashed
                    li Import a video or capture with the built-in camera
                    li Set the Exposure Time
                    li Adjust the timeline
                    li Export as H.264, HEVC, PNG, GIF, or Live Photo
          
          //Persecond
          .gridItem#mobile(v-show='showingPersecond')
            .gridItem--image
                img.lazy(data-src='https://cdn.flixel.com/static/static-web/products/pricing/professional.png')
            .gridItem--title
                h2 Persecond
                h3 Create beautiful time lapses effortlessly
                p The easiest app to create a timelapse from a series of images for macOS.
            .gridItem--pricing(v-if='showingMonthly')
                h4 {{persecondMonthly}}
                    span  / month
                p Save {{persecondYearlySave}} with  
                    a.link(@click='showYearly()') yearly billing
            .gridItem--pricing(v-if='!showingMonthly')
                h4 {{persecondYearlyPerMonth}}
                    span / month
                p 
                    span {{persecondYearly}} 
                    | billed yearly. 
                p Save {{persecondYearlySave}} over  
                    a.link(@click='showMonthly()') monthly billing
                      
            .gridItem--pricing
                // Monthly button
                buy-button(
                    classes='btn btn--purpleLight',
                    product='fpsmac-month',
                    copy='Buy Now',
                    v-if='showingMonthly'
                )
                // Yearly button
                buy-button(
                    classes='btn btn--purpleLight',
                    product='fpsmac-year',
                    copy='Buy Now',
                    v-if='!showingMonthly'
                )
            .gridItem--subtitle
                h5.includeTitleDesktop Includes:
                h5.includeTitleMobile Includes:
                .moreFeatures#moreFeaturesMobile(@click='showFeature("mobile", "moreFeaturesMobile", "featuresMobile")')
                    h5 Show Features
                    i.fa.fa-chevron-down
            .gridItem__products
                .gridItem--product.gridItem--product--grey
                    h6
                        img.lazy(data-src='https://cdn.flixel.com/static/static-web/purchase/Check.svg')
                        | Persecond
                        span &nbsp;for macOS
            .gridItem--features#featuresMobile
                ul.dashed
                    li Import or drag and drop a set of images
                    li Adjust the start and end frames
                    li Set the duration and frame rate
                    li Export as H.264, HEVC, and Apple ProRes
          .gridItem#mobile(v-show='!showingPersecond || showingBlendeo')
            .gridItem--image
              img.lazy(data-src='https://cdn.flixel.com/static/static-web/products/pricing/mobile.png')
            .gridItem--title
              h2 Mobile
              h3 Small Businesses &amp; Content Creators
              p Shoot, edit, and export from your phone with the mobile cinemagraph studio.
            .gridItem--pricing(v-if='showingMonthly')
              h4 {{mobileMonthly}}
                span  / month
              p Save {{mobileYearlySave}} with
                a.link(@click='showYearly()')  yearly billing
            .gridItem--pricing(v-if='!showingMonthly')
              h4 {{mobileYearlyPerMonth}}
                span  / month
              p
                span {{mobileYearly}} billed yearly.
              p Save {{mobileYearlySave}} over
                a.link(@click='showMonthly()')  monthly billing

            .gridItem--pricing
              // Monthly button
              buy-button(
                classes='btn btn--purpleLight',
                product='fmp-m',
                copy='Buy Now',
                v-if='showingMonthly'
              )
              // Yearly button
              buy-button(
                classes='btn btn--purpleLight',
                product='fmp-y',
                copy='Buy Now',
                v-if='!showingMonthly'
              )
            .gridItem--subtitle
              h5.includeTitleDesktop Includes:
              h5.includeTitleMobile Includes:
              .moreFeatures#moreFeaturesMobile(@click='showFeature("mobile", "moreFeaturesMobile", "featuresMobile")')
                h5 Show Features
                i.fa.fa-chevron-down
            .gridItem__products
              .gridItem--product.gridItem--product--grey
                h6
                  img.lazy(data-src='https://cdn.flixel.com/static/static-web/purchase/Check.svg')
                  | Cinemagraph Pro
                  span &nbsp;for iOS
              .gridItem--product
                h6
                  img.lazy(data-src='https://cdn.flixel.com/static/static-web/purchase/Check.svg')
                  | Blendeo
                  span &nbsp;for iOS
            .gridItem--features#featuresMobile
              ul.dashed
                li Shoot from iPhone or iPad
                li Export and share cinemagraphs on all social networks
                li Optimized for use with Facebook Ads Manager
                li Explore 1000s of cinemagraphs in over 40 themed galleries

          // Professional
          .gridItem#pro
            .gridItem--image
              img.lazy(data-src='https://cdn.flixel.com/static/static-web/products/pricing/professional.png')
            .gridItem--title
              h2 Professional
              h3 Photographers &amp; Marketers
              p Use your computer and photography equipment to create commercial quality cinemagraphs that your clients will love.
            .gridItem--pricing(v-if='showingMonthly')
              h4 {{proMonthly}}
                span  / month
              p Save {{proYearlySave}} with
                a.link(@click='showYearly()')  yearly billing
            .gridItem--pricing(v-if='!showingMonthly')
              h4 {{proYearlyPerMonth}}
                span  / month
              p {{proYearly}} billed yearly.
              p Save {{proYearlySave}} over
                a.link(@click='showMonthly()')  monthly billing
            .gridItem--pricing
              // Monthly plan
              buy-button(
                classes='btn btn--purpleLight',
                product='fpp-m',
                copy='Buy Now',
                v-if='showingMonthly'
              )
              // Yearly plan
              buy-button(
                classes='btn btn--purpleLight',
                product='fpp-y',
                copy='Buy Now',
                v-if='!showingMonthly'
              )
            .gridItem--subtitle
              h5.includeTitleDesktop Includes:
              h5.includeTitleMobile Includes:
              .moreFeatures#moreFeaturesPro(@click='showFeature("pro", "moreFeaturesPro", "featuresPro")')
                h5 Show Features
                i.fa.fa-chevron-down
            .gridItem__products
              .gridItem--product.gridItem--product--grey
                h6
                  img.lazy(data-src='https://cdn.flixel.com/static/static-web/purchase/Check.svg')
                  | Cinemagraph Pro
                  span &nbsp;for iOS
              .gridItem--product
                h6
                  img.lazy(data-src='https://cdn.flixel.com/static/static-web/purchase/Check.svg')
                  | Cinemagraph Pro
                  span &nbsp;for macOS
              .gridItem--product.gridItem--product--grey
                h6
                  img.lazy(data-src='https://cdn.flixel.com/static/static-web/purchase/Check.svg')
                  | Persecond
                  span &nbsp;for macOS
              .gridItem--product
                h6
                  img.lazy(data-src='https://cdn.flixel.com/static/static-web/purchase/Check.svg')
                  | Blendeo
                  span &nbsp;for iOS
            .gridItem--features#featuresPro
              ul.dashed
                li Full desktop editing experience
                li Upload footage from your DSLR camera
                li Shoot, edit, and export cinemagraphs
                li Create and save your own colour presets
          
          //Business
          .gridItem#business(v-show='showingPersecond || !showingBlendeo')
            .gridItem--image
              img.lazy(data-src='https://cdn.flixel.com/static/static-web/products/pricing/business.png')
            .gridItem--title
              h2 Business
              h3 Large Businesses &amp; Agencies
              p All of the tools and training you need to create cinemagraphs for your website, marketing, social media, and more.
            .gridItem--pricing(v-if='showingMonthly')
              h4 {{businessMonthly}}
                span  / month
              p Save {{businessYearlySave}} with
                a.link(@click='showYearly()')  yearly billing
            .gridItem--pricing(v-if='!showingMonthly')
              h4 {{businessYearlyPerMonth}}
                span  / month
              p {{businessYearly}} billed yearly.
              p Save {{businessYearlySave}} over
                a.link(@click='showMonthly()')  monthly billing
            .gridItem--pricing
              // Monthly plan
              buy-button(
                classes='btn btn--purpleLight',
                product='fbp-m',
                copy='Buy Now',
                v-if='showingMonthly'
              )
              // Yearly plan
              buy-button(
                classes='btn btn--purpleLight',
                product='fbp-y',
                copy='Buy Now',
                v-if='!showingMonthly'
              )
            .gridItem--subtitle
              h5.includeTitleDesktop Includes:
              h5.includeTitleMobile Includes:
              .moreFeatures#moreFeaturesBusiness(@click='showFeature("business", "moreFeaturesBusiness", "featuresBusiness")')
                h5 Show Features
                i.fa.fa-chevron-down
            .gridItem__products
              .gridItem--product.gridItem--product--grey
                h6
                  img.lazy(data-src='https://cdn.flixel.com/static/static-web/purchase/Check.svg')
                  | Cinemagraph Pro
                  span &nbsp;for iOS
              .gridItem--product
                h6
                  img.lazy(data-src='https://cdn.flixel.com/static/static-web/purchase/Check.svg')
                  | Cinemagraph Pro
                  span &nbsp;for macOS
              .gridItem--product.gridItem--product--grey
                h6
                  img.lazy(data-src='https://cdn.flixel.com/static/static-web/purchase/Check.svg')
                  | Persecond
                  span &nbsp;for macOS
              .gridItem--product
                h6
                  img.lazy(data-src='https://cdn.flixel.com/static/static-web/purchase/Check.svg')
                  | Blendeo
                  span &nbsp;for iOS
              .gridItem--product.gridItem--product--grey
                h6
                  img.lazy(data-src='https://cdn.flixel.com/static/static-web/purchase/Check.svg')
                  | HD Cinemagraph Hosting
            .gridItem--features#featuresBusiness
              ul.dashed
                li Unlimited cinemagraph uploads
                li Embed perfectly looping cinemagraphs on your websites and blogs
                li Continued support and advice from Flixel
                li 100,000 HD embed views/month

    section.pricing__callout
      .pricing__callout--video
        .pricing__callout--text
          h2 Large organization?<br> Learn how Flixel works with our enterprise customers.
          p Our Enterprise plans include additional cinemagraph solutions, such as stills-to-motion campaigns, consultation with the experts at Flixel Studios, multiple subscriptions for your entire team, and more.
          router-link(to='/enterprise')
            button.btn.btn--white Learn More
        .pricing__overlay--shadow
        iframe.mobileVideo(data-src='https://media.flixel.com/cinemagraph/ed55jyjd0qe0dd4icx64?hd=true' allow='autoplay')
        iframe.desktopVideo(data-src='https://media.flixel.com/cinemagraph/o0dzpxdzkx7jcndvnd80?hd=true' allow='autoplay')

    section.pricing__section
      .pricing__faq--container
        .pricing__faq--title
          h2 FAQ
        .pricing__faq--grid
          .gridItem--divider
          .gridItem
            .gridItem--title
              h3 Do you offer educational or non-profit pricing?
            .gridItem--subtitle
              h4 Yes, we do!
            .gridItem--desc
              p Students, teachers, nonprofit, and charitable organizations are eligible to receive a 50% discount on all products sold on the Flixel Store. Learn which products are eligible and how to apply for the discount on
                a(href='http://support.flixel.com/products-overview-and-pricing/purchasing/educational-and-nonprofit-pricing')  this page.
          .gridItem--divider
          .gridItem
            .gridItem--title
              h3 Do you offer business plans with more than 100,000 embed views/month?
            .gridItem--subtitle
              h4 Yes, we do!
            .gridItem--desc
              p Additional embed views are available in increments of 100,000. Contact us for more information about upgrading your plan.
          .gridItem--divider
          .gridItem
            .gridItem--title
              h3 Will I be required to pay tax?
            .gridItem--subtitle
              h4 Possibly, but not for US or Canada.
            .gridItem--desc
              p Customers in countries outside of the US or Canada may be required to pay tax on digital products.
              p Paddle, our eCommerce provider, is required to collect VAT (Value Added Tax or Sales Tax) on digital products sold to consumers within the EU and a growing number of other countries. If you work for a VAT-registered business, learn how to submit your VAT number on
                a(href='http://support.flixel.com/products-overview-and-pricing/purchasing/vat-value-added-tax')  this page.
          .gridItem--divider
          .gridItem
            .gridItem--title
              h3 Will the subscription renew automatically?
            .gridItem--subtitle
              h4 Yes
            .gridItem--desc
              p Subscriptions renew automatically but can be cancelled at any time prior to renewal.
              p You will be sent an email reminder a few weeks before your subscription renews. You can cancel your plan at any time and continue using it for the remainder of the subscription period.
          .gridItem--divider

    section.pricing__callout.pricing__callout--footer
      .pricing__callout--video
        .pricing__callout--text.pricing__callout--lefttext
          h2 Start Making Cinemagraphs with Cinemagraph Pro
          p Create thumb-stopping visuals to use on your website, social, presentations and more. Get started today with a free trial of Cinemagraph Pro.
        .pricing__overlay--shadow
        iframe.mobileVideo(data-src='https://media.flixel.com/cinemagraph/csn656rpj8c1nfsbzl0n?hd=true' allow='autoplay')
        iframe.desktopVideo(data-src='https://media.flixel.com/cinemagraph/csn656rpj8c1nfsbzl0n?hd=true' allow='autoplay')

    section.pricing__footer
      .footer--text
        h2 Start Making Cinemagraphs with Cinemagraph Pro
        p Create thumb-stopping visuals to use on your website, social, presentations and more. Get started today with a free trial of Cinemagraph Pro.
</template>

<script>
import buyButton from 'components/buyButton.vue';
import buyModal from 'components/buyModal.vue';
import productsService from 'services/products.es6.js';

import eventBus from '../../eventBus.js';

export default {
  name: 'pricing',
  data() {
    return {
      flag: false,
      currency: '$',
      showingPersecond: '',
      persecondMonthly: '$4.99',
      persecondYearlyPerMonth: '$2.50',
      persecondYearly: '$29.99',
      persecondYearlySave: '$29',

      showingBlendeo: '',
      blendeoMonthly: '$4.99',
      blendeoYearlyPerMonth: '$2.50',
      blendeoYearly: '$29.99',
      blendeoYearlySave: '$29',

      showingMonthly: this.$route.query.m === '1',
      mobileMonthly: '$14.99',
      mobileYearlyPerMonth: '$8.33',
      mobileYearly: '$99.99',
      mobileYearlySave: '$79',

      proMonthly: '$29.99',
      proYearlyPerMonth: '$16.66',
      proYearly: '$199.99',
      proYearlySave: '$159',

      businessMonthly: '$49.99',
      businessYearlyPerMonth: '$24.99',
      businessYearly: '$299.99',
      businessYearlySave: '$299',
    };
  },
  created() {
    if (this.$route.query.fps) {
      this.showingPersecond = this.$route.query.fps;
    }
    if (this.$route.query.blendeo) {
      this.showingBlendeo = this.$route.query.blendeo;
    }

    if (this.showingPersecond) {
      // Get Persecond Prices
      this.getPrices(537213, 537212);
    } else if (this.showingBlendeo) {
      // Get Blendeo Prices
      this.getPrices(552713, 552712);
    }
    // Get Mobile and Yearly Prices
    this.getPrices(529806, 526021);
    // Get Pro and Yearly Prices
    this.getPrices(529807, 523574);
    // Get Business prices
    this.getPrices(529808, 523573);
  },
  mounted() {
    const myLazyLoad = new LazyLoad({
      elements_selector: 'iframe, .lazy',
    });
    $(window).ready(function () {
      $(window).scrollTop(0);
    });
    if (this.$route.query.coupon) {
      this.coupon = this.$route.query.coupon;
      localStorage.setItem('coupon', this.$route.query.coupon);
      if (this.coupon === '1DOLLARDEAL') {
        eventBus.$emit('1DollarBuy');
      }
    } else if (localStorage.getItem('coupon')) {
      this.coupon = localStorage.getItem('coupon');
    } else {
      this.coupon = '';
    }
  },
  methods: {
    showMonthly() {
      this.showingMonthly = true;
    },
    showYearly() {
      this.showingMonthly = false;
    },
    discount(price, discount) {
      return (Number(price.replace(/[^0-9\.]+/g, '')) * discount).toFixed(2);
    },
    getPrices(monthlyID, yearlyID) {
      const self = this;
      const setPrice = function (response) {
        if (response.id === 529806) {
          self.mobileMonthly = response.price;
        } else if (response.id === 529807) {
          self.proMonthly = response.price;
        } else if (response.id === 529808) {
          self.businessMonthly = response.price;
        } else if (response.id === 537213) {
          self.persecondMonthly = response.price;
        } else {
          console.log('Error');
        }
      };
      const getMonthly = new Promise(function (resolve) {
        window.Paddle.Product.Prices(monthlyID, function (prices) {
          const payload = {
            price: prices.price.gross,
            id: monthlyID,
          };
          resolve(payload);
        });
      });
      const getYearly = function (id) {
        return new Promise(function (resolve) {
          window.Paddle.Product.Prices(yearlyID, function (prices) {
            const payload = {
              price: prices.price.gross,
              // Black Friday type discount
              // price: self.discount(prices.price.gross, 0.7),
              id: yearlyID,
              currency: prices.price.gross.replace(/[\d,.]/g, ''),
            };
            resolve(payload);
          });
        });
      };
      getMonthly.then(function (response) {
        setPrice(response);
        getYearly(response.id).then(function (res) {
          if (yearlyID === 526021) {
            self.currency = res.currency;
            self.mobileYearly = res.price;
            self.mobileYearlyPerMonth = self.currency
              + ''
              + (res.price.replace(/[^\d.]/g, '') / 12).toFixed(2);
            self.mobileYearlySave = self.currency
              + ''
              + Math.floor(
                parseFloat(self.mobileMonthly.replace(/[^\d.]/g, '') * 12)
                - res.price.replace(/[^\d.]/g, ''),
              );
          } else if (yearlyID === 523574) {
            self.currency = res.currency;
            self.proYearly = res.price;
            self.proYearlyPerMonth = self.currency
              + ''
              + (res.price.replace(/[^\d.]/g, '') / 12).toFixed(2);
            self.proYearlySave = self.currency
              + ''
              + Math.floor(
                parseFloat(self.proMonthly.replace(/[^\d.]/g, '') * 12)
                - res.price.replace(/[^\d.]/g, ''),
              );
          } else if (yearlyID === 523573) {
            self.currency = res.currency;
            self.businessYearly = res.price;
            self.businessYearlyPerMonth = self.currency
              + ''
              + (res.price.replace(/[^\d.]/g, '') / 12).toFixed(2);
            self.businessYearlySave = self.currency
              + ''
              + Math.floor(
                parseFloat(self.businessMonthly.replace(/[^\d.]/g, '') * 12)
                - res.price.replace(/[^\d.]/g, ''),
              );
          } else if (yearlyID === 537212) {
            self.currency = res.currency;
            self.persecondYearly = res.price;
            self.persecondYearlyPerMonth = self.currency
              + ''
              + (res.price.replace(/[^\d.]/g, '') / 12).toFixed(2);
            self.persecondYearlySave = self.currency
              + ''
              + Math.floor(
                parseFloat(self.persecondMonthly.replace(/[^\d.]/g, '') * 12)
                - res.price.replace(/[^\d.]/g, ''),
              );
          } else if (yearlyID === 552712) {
            self.currency = res.currency;
            self.blendeoYearly = res.price;
            self.blendeoYearlyPerMonth = self.currency
              + ''
              + (res.price.replace(/[^\d.]/g, '') / 12).toFixed(2);
            self.blendeoYearlySave = self.currency
              + ''
              + Math.floor(
                parseFloat(self.persecondMonthly.replace(/[^\d.]/g, '') * 12)
                - res.price.replace(/[^\d.]/g, ''),
              );
          }
        });
      });
    },
    showFeature(id, button, features) {
      if (!this.flag) {
        document.getElementById(id).style.height = '100%';
        document.getElementById(button).childNodes[0].innerHTML = 'Less Features';
        document.getElementById(button).childNodes[1].style.transform = 'rotate(180deg)';
        document.getElementById(features).classList.add('gridItem--featuresMobile');
        this.flag = !this.flag;
      } else {
        document.getElementById(id).style.height = '';
        document.getElementById(button).childNodes[0].innerHTML = 'Show Features';
        document.getElementById(button).childNodes[1].style.transform = 'rotate(0)';
        document.getElementById(features).classList.remove('gridItem--featuresMobile');
        this.flag = !this.flag;
      }
    },
  },
  components: {
    'buy-button': buyButton,
    'buy-modal': buyModal,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/products/pricing.vue